import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { signIn, signUpBackend } from '../services/AuthService';
import Loading from '../components/Common/Loading';
import 'bootstrap/dist/css/bootstrap.min.css';
import {
  Alert,
  Button,
  Container,
  Form,
  Card
} from 'react-bootstrap';

const LoginPage = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [givenName, setGivenName] = useState('');
  const [familyName, setFamilyName] = useState('');
  const [isSignUp, setIsSignUp] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');
  const [successMessage, setSuccessMessage] = useState('');
  const navigate = useNavigate();

  const handleSignIn = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setError('');
    try {
      const session = await signIn(email, password);
      if (session && session.IdToken) {
        window.location.href = '/';
      } else {
        throw new Error('Session token was not set properly.');
      }
    } catch (error) {
      setError(`Sign in failed: ${error.message}`);
    } finally {
      setIsLoading(false);
    }
  };

  const handleSignUp = async (e) => {
    e.preventDefault();
    if (password !== confirmPassword) {
      setError('Passwords do not match');
      return;
    }
    setIsLoading(true);
    setError('');
    setSuccessMessage('');
    try {
      const response = await signUpBackend(email, password, givenName, familyName);
      setSuccessMessage(response.message);
      setEmail('');
      setPassword('');
      setConfirmPassword('');
      setGivenName('');
      setFamilyName('');
      setIsSignUp(false);
    } catch (error) {
      if (error.response && error.response.data && error.response.data.message) {
        setError(`Sign up failed: ${error.response.data.message}`);
      } else {
        setError(`Sign up failed: ${error.message}`);
      }
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Container className="d-flex justify-content-center align-items-center vh-100">
      <Card className="p-4 shadow-lg position-relative" style={{ maxWidth: '400px', width: '100%' }}>
        {isLoading ? (
          <Card.Body>
            <Card.Text className='text-center'>
              {isSignUp ? 'Kindly wait while we\'re storing all your data for potential blackmailing-purposes!' : 'Please wait while we\'re logging you in!'}
            </Card.Text>
            <Loading />
          </Card.Body>
        ) : (
          <Card.Body>
            {successMessage ? (
              <Alert variant="success" dismissible onClose={() => setSuccessMessage('')}>
                {successMessage}
              </Alert>
            ) : (
              <>
                <Card.Title className="text-center mb-4">
                  {isSignUp ? 'Create an Account' : 'Sign in to Your Account'}
                </Card.Title>
                <Form onSubmit={isSignUp ? handleSignUp : handleSignIn}>
                  <Form.Group className="mb-3" controlId="formEmail">
                    <Form.Label>Email address</Form.Label>
                    <Form.Control
                      // type="email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      placeholder="Enter email"
                      required
                    />
                  </Form.Group>
                  <Form.Group className="mb-3" controlId="formPassword">
                    <Form.Label>Password</Form.Label>
                    <Form.Control
                      type="password"
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                      placeholder="Password"
                      required
                    />
                  </Form.Group>
                  {isSignUp && (
                    <>
                      <Form.Group className="mb-3" controlId="formConfirmPassword">
                        <Form.Control
                          type="password"
                          value={confirmPassword}
                          onChange={(e) => setConfirmPassword(e.target.value)}
                          placeholder="Confirm Password"
                          required
                        />
                      </Form.Group>
                      <Form.Group className="mb-3" controlId="formGivenName">
                        <Form.Label>Given Name</Form.Label>
                        <Form.Control
                          type="text"
                          value={givenName}
                          onChange={(e) => setGivenName(e.target.value)}
                          placeholder="Enter given name"
                          required
                        />
                      </Form.Group>
                      <Form.Group className="mb-3" controlId="formFamilyName">
                        <Form.Label>Family Name</Form.Label>
                        <Form.Control
                          type="text"
                          value={familyName}
                          onChange={(e) => setFamilyName(e.target.value)}
                          placeholder="Enter family name"
                          required
                        />
                      </Form.Group>
                    </>
                  )}
                  {error && (
                    <Alert variant="danger" dismissible onClose={() => setError('')}>
                      {error}
                    </Alert>
                  )}
                  <Button type="submit" disabled={isLoading} className="w-100">
                    {isSignUp ? 'Sign Up' : 'Sign In'}
                  </Button>
                </Form>
                <Button className="d-block w-100 mt-3 text-center" onClick={() => setIsSignUp(!isSignUp)}>
                  {isSignUp ? 'Already have an account? Sign In' : 'Need an account? Sign Up'}
                </Button>
              </>
            )}
          </Card.Body>
        )}
      </Card>
    </Container>
  );
};

export default LoginPage;
